// =========== [WireVault API Swagger documentation] ===========
// https://admin.dev.wirevault-beta.com/swagger/

export const HTTP_SUCCESS_STATUS = 200;
export const HTTP_UNAUTHORIZED_STATUS = 401;
export const HTTP_FORBIDDEN_STATUS = 403;
export const HTTP_TOO_MANY_REQUESTS_STATUS = 429;
export const HTTP_BAD_REQUEST_STATUS = 400;

export const TEXT_HTML_CONTENT_TYPE = 'text/html; charset=utf-8';
export const APPLICATION_JSON_CONTENT_TYPE = 'application/json';
export const APPLICATION_PDF_CONTENT_TYPE = 'application/pdf';
export const APPLICATION_CSV_CONTENT_TYPE = 'text/csv';
export const APPLICATION_MS_EXCEL_CONTENT_TYPE = 'application/vnd.ms-excel';

export const INVALID_TOKEN_RESPONSE = 'Token is invalid or expired';
export const BLOCKED_USER_RESPONSE = 'You don`t have access to this application.';
export const INVALID_PASSWORD_RESPONSE = 'No active account found with the given credentials.';
export const ACCESS_DENIED_RESPONSE = 'User has no rights to perform this action';
export const ACTIVATION_TOKEN_INVALID_RESPONSE = 'Activation token is invalid';
export const ONBOARDING_USER_ALREADY_EXISTS = 'User is already active';
export const EXPIRED_TOKEN_ERROR_TYPE = 'InvalidToken';
export const ORGANIZATION_USER_LIMIT_REACH_ERROR_MESSAGE =
  'Organization user limit reached. Please upgrade your subscription to add more members.';
export const UNEXPECTED_RESPONSE_ERROR_TYPE = 'UnexpectedError';
export const TRIAL_MODE_SUBSCRIPTION_REQUIRED_ERROR_MESSAGE =
  'This action forbidden for trial mode. Please buy subscription.';

export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const DEFAULT_LANGUAGE = 'en';
